import { render, staticRenderFns } from "./FormularioChofer.vue?vue&type=template&id=4da12bdf&"
import script from "./FormularioChofer.vue?vue&type=script&lang=ts&"
export * from "./FormularioChofer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports